/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
//import moment from 'moment';
import reviewUtil from '../../../objects/reviewUtil';

class workflowModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("reviewApprove");
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.selectedJob = ko.observable(params.selectedJob);
        this.messageObj = params.messageObj;

        this.startStopCss = ko.observable("");
        this.addValid = ko.observable(true);
        this.startValid = ko.observable(false);

        this.buttonsVisible = ko.observable(true);

        this.startStopLabel = ko.computed(function() {

            //console.log(this.selectedJob);

            if(this.selectedJob === undefined)
            {
                this.startStopCss("");
                return "Start...";
            }
            
            if(this.selectedJob().statusid() === 0)
            {
                this.addValid(true);
                this.startStopCss("btn-success");
                this.startValid(true);
                this.addValid(true);
                return "Start";
            }

            if(this.selectedJob().statusid() === 1)
            {
                this.addValid(true);
                this.startStopCss("btn-success");
                this.startValid(true);
                this.addValid(true);
                return "Start";
            }

            if(this.selectedJob().statusid() === 2)
            {
                this.addValid(true);
                this.startStopCss("btn-danger");
                this.startValid(true);
                this.addValid(false);
                return "Stop";
            }

            if(this.selectedJob().statusid() === 3)
            {
                this.addValid(false);
                this.startStopCss("btn-danger");
                this.startValid(true);
                this.addValid(false);
                return "Stop";
            }

            if(this.selectedJob().statusid() === 4)
            {
                this.addValid(true);
                this.startStopCss("btn-warning");
                this.addValid(false);
                this.startValid(true);
                return "Rerun";
            }
            
            if(this.selectedJob().statusid() === 9)
            {
                this.addValid(true);
                this.startStopCss("btn-warning");
                this.addValid(false);
                this.startValid(true);
                return "Rerun";
            }

            this.addValid(true);
            this.startValid(false);
            return "Start"

        }, this);


        console.log("workflowModel");
        console.log(params);


        this.init();
    }

    init() {

        this.messageObj.subscribe( messageObj =>  {

            //console.log("****** TabReviewApprove:init:messageObj: %o %s", messageObj, messageObj.event);

            switch(messageObj.event)
            {
                case "refresh":
                    
                    console.log("Processing Refresh");
                    this.selectedJob(messageObj.selectedJob);
                    this.selectedJob().workflowArray.valueHasMutated();
                    //console.table(this.selectedJob);
                    //console.log("**** tabReviewApprove:init:messageObj %o", this.selectedJob.workflowArray());
                    //alert(this.selectedJob.workflowArray().length);
                    break;
            }


        });

        if(this.context.loginStatusObj().Mode == "Review")
        {
            this.addValid(false);
            this.startValid(false);
            this.buttonsVisible(false);
        }
    }

    addWorkflowItem(jobObj)
    {
        console.log("addWorkflowItem: jobObj: %o", jobObj);
    
        context.eventManager.notifySubscribers({"workflowItem":this,"jobObj":jobObj},"review-Object-Modal");
    }

    startStopWorkflow(jobObj)
    {

        console.log("tabReviewApprove:startStopWorkflow: jobObj: %o  item: %o", jobObj, this.selectedJob());

        let self = this;
        let reviewUtilObj = new reviewUtil(this.context);

        switch(this.selectedJob().statusid())
        {
            //Start to InReview
            case 0:
            console.log("tabReviewApprove:startStopWorkflow :0-2");
            this.selectedJob().statusid(2);
            this.selectedJob().startReview(this.context);
            break;

            //InActive to InReview
            case 1:
            this.selectedJob().statusid(2);
            console.log("tabReviewApprove:startStopWorkflow: 1-2");
            this.selectedJob().startReview(this.context);
            break;

            //InReview to Stop
            case 2:
            console.log("tabReviewApprove:startStopWorkflow : 2-9");
            this.selectedJob().stopReview(this.context);
            this.selectedJob().statusid(9);
            break;    
            
            //Stop to Go
            case 9:
            console.log("tabReviewApprove:startStopWorkflow ReRun startStopWorkflow: 9-1");
            //jobObj.stopReview(this.context);
            this.selectedJob().statusid(1);
            break; 

            default:
            // this.Raven.captureMessage('tabReviewApprove:startStopWorkflow - statsid value not found in switch', {level:'error'});
            console.log("tabReviewApprove:startStopWorkflow:Error jobObj: %o  item: %o", jobObj, this.selectedJob());
            break;

            /*
            //Stop to Start
            case 3:
            console.log("startStopWorkflow: 3");
            this.selectedJob.statusid(1);
            break;

            //Done to Start
            case 9:
            console.log("startStopWorkflow: 9");
            this.selectedJob.statusid(0);
            break;
            */
        }
    }

}

export default { viewModel: workflowModel, template: require('!raw-loader!./tabReviewApprove.html') };


// WEBPACK FOOTER //
// ./src/components/review/tabReviewApprove/tabReviewApprove.js